import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { combineStyles } from "@universityofmaryland/web-utilities-library/styles";
import { createCompositeCarouselBlocks } from "../elements/equal-width-items.js";
import { buttonColorsOnWhite } from "../elements/nav-button.js";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import { fullscreen } from "../../../atomic/buttons/fullscreen.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import { createCompositeCarouselOverlay } from "../elements/overlay.js";
import "@universityofmaryland/web-utilities-library/events";
import { createLayoutImageContainer } from "../../../layout/image.js";
const fullScreenClassName = fullscreen.className;
const createCompositeCarouselImageMultiple = (props) => (() => {
  const { images, isThemeDark, isFullScreenOption = false, isToggleCaption = true } = props;
  const clonedImages = images.map((image) => image.cloneNode(true));
  const slide = new ElementBuilder().build().element;
  const overlayCarousel = createCompositeCarouselOverlay({ images, isToggleCaption });
  let buttonStyles = "";
  let blockStyles = "";
  let containerClass = "";
  const blockModels = clonedImages.map((image, index$1) => {
    const block = createLayoutImageContainer({ image, showCaption: true, isToggleCaption });
    containerClass = block.element.className;
    if (isFullScreenOption) {
      const button = fullscreen.create({
        callback: overlayCarousel.events.setFullScreen,
        index: index$1
      });
      block.element.appendChild(button.element);
      buttonStyles += button.styles;
    }
    blockStyles += block.styles;
    return block.element;
  });
  const carousel = createCompositeCarouselBlocks.CreateElement({
    blocks: blockModels,
    slide,
    mobileBreakpoint: token.media.breakpointValues.medium.max,
    tabletBreakpoint: token.media.breakpointValues.desktop.min,
    desktopBreakpoint: token.media.breakpointValues.highDef.max,
    desktopCount: 3,
    maxCount: 4,
    showHint: false,
    fullScreenCallback: overlayCarousel.events.setFullScreen,
    button: {
      ...buttonColorsOnWhite(isThemeDark)
    }
  });
  const containerModel = new ElementBuilder().withClassName("carousel-image-multiple-container").withStyles({
    element: {
      overflow: "hidden",
      ...isThemeDark && { backgroundColor: token.color.black }
    }
  }).withChild(carousel).build();
  const declarationModel = new ElementBuilder().withClassName("carousel-image-multiple-declaration").withStyles({
    element: {
      containerType: "inline-size",
      [`& .${containerClass} img`]: { objectFit: "cover" }
    }
  }).withStylesIf(isFullScreenOption, {
    element: {
      // Only hide/reveal the Full Screen button on devices that actually
      // hover. On touch (hover: none) the button stays visible by default —
      // and, crucially, no `:hover` rule exists on this container, so iOS
      // Safari does not swallow the first tap as a hover. A hover-reveal on
      // the container would make iOS treat the first tap on the caption
      // toggle (a child of this container) as a hover instead of a click.
      "@media (hover: hover)": {
        [`& .${fullScreenClassName}`]: {
          visibility: "hidden",
          opacity: 0,
          transition: "visibility 0s, opacity 0.5s linear",
          "&:focus": { visibility: "visible", opacity: 1 }
        },
        [`& .${containerClass}:focus-within .${fullScreenClassName}`]: {
          visibility: "visible",
          opacity: 1
        },
        [`& .${containerClass}:hover .${fullScreenClassName}`]: {
          visibility: "visible",
          opacity: 1
        }
      }
    }
  }).withChild(containerModel).withEvents({ SetEventReize: carousel.events.resize }).build();
  declarationModel.styles = combineStyles(
    declarationModel.styles,
    blockStyles,
    overlayCarousel.styles,
    buttonStyles
  );
  images[images.length - 1].addEventListener("load", () => {
    carousel.events.load();
    setTimeout(() => {
      const maxHeight = clonedImages.reduce(
        (accumulator, image) => Math.max(image.offsetHeight, accumulator),
        300
      );
      slide.style.minHeight = `${maxHeight}px`;
    }, 100);
  });
  if (isFullScreenOption) {
    const wrapperModel = new ElementBuilder().withChild(declarationModel).withModifier((element) => {
      element.insertAdjacentElement("afterbegin", overlayCarousel.element);
    }).withEvents({ SetEventReize: carousel.events.resize }).build();
    return wrapperModel;
  }
  return declarationModel;
})();
export {
  createCompositeCarouselImageMultiple
};
//# sourceMappingURL=multiple.js.map
